import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import Mashy from "@/components/Mashy";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { fetchMe } = useAuth();
  const processed = React.useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        await api.post("/auth/session", { session_id });
        const user = await fetchMe();
        if (user && !user.onboarded) navigate("/onboarding", { replace: true });
        else if (user?.role === "teacher") navigate("/teacher", { replace: true });
        else if (user?.role === "course_creator") navigate("/creator/modules", { replace: true });
        else navigate("/dashboard", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [location, navigate, fetchMe]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <Mashy mood="happy" size={140} />
      <p className="font-display text-xl text-gray-700">Welcoming you to Mashy...</p>
    </div>
  );
}
